import React, { ReactNode } from "react"
import { FilterChooser, FilterChooserProps } from "../Button/FilterChooser"
import { SortChooserProps, SortChooser } from "../Button/SortChooser"
import { TableViewChooserProps, TableViewChooser } from "./TableViewChooser"

export interface TableHeaderProps<M, V extends string> {
    /**
     * Number of items including those which are not yet fetched from server and also excluded by the filter.
     */
    totalCount?: number
    /**
     * Things to be rendered along with filter, sort and view button
     */
    extraActions?: ReactNode
    /**
     * Configuration for filtering
     */
    filterOptions?: FilterChooserProps<M>
    /**
     * Filtered items count
     */
    filteredCount?: number
    /**
     * Configuration for sorting
     */
    sortOptions?: SortChooserProps<M>
    /**
     * Configuration for switching views
     */
    viewOptions?: TableViewChooserProps<V>
    className?: string
}

export function TableHeader<M, V extends string = "default">({
    extraActions,
    totalCount,
    filterOptions,
    filteredCount,
    sortOptions,
    viewOptions,
    className
}: TableHeaderProps<M, V>) {
    return (
        <div
            className={`flex justify-between items-center py-3 z-20 ${
                className ?? ""
            }`}
        >
            <p className="text-smoke-610 pr-2">
                {totalCount === undefined ||
                (filterOptions !== undefined && filteredCount === undefined)
                    ? null
                    : filteredCount === undefined ||
                      filteredCount === totalCount
                    ? `Showing all ${totalCount}`
                    : `Showing ${filteredCount} (of ${totalCount})`}
            </p>
            <div className="flex">
                {sortOptions === undefined ? null : (
                    <div className="ml-2 flex">
                        <SortChooser
                            {...sortOptions}
                            testId="table-sort-chooser"
                            classNameOpen="text-smoke-610 shadow-none"
                            classNameClosed="text-smoke-610 shadow-none"
                        />
                    </div>
                )}
                {filterOptions === undefined ? null : (
                    <div className="ml-2 flex">
                        <FilterChooser
                            {...filterOptions}
                            testId="table-filter-chooser"
                        />
                    </div>
                )}
                {viewOptions === undefined ? null : (
                    <div className="ml-2 flex">
                        <TableViewChooser {...viewOptions} />
                    </div>
                )}
                {extraActions}
            </div>
        </div>
    )
}
